<template>
  <div id="app">
    <AppHeader v-if="!isLoginPage" />
    <router-view />
    <AppFooter v-if="!isLoginPage" />
  </div>
</template>

<script>

import AppHeader from './components/Header.vue';
import AppFooter from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  },
  computed: {
    isLoginPage() {
      return this.$route.path === '/login';
    }
  }
}
</script>

<style>
/* Global Styles (optional) */
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

router-view {
  flex: 1;
}
</style>
